/**
 * Centralised contact information for AutoXChange.
 * Update values here and they propagate across the entire site
 * (Footer, Kontakt, Bil-detalje, JSON-LD, chat-fallback, login-footer).
 */
export const CONTACT = {
  companyName: "AutoXChange ApS",
  cvr: "33882386",
  vatID: "DK33882386",

  // Phone
  phoneDisplay: "+45 53 35 86 39",
  phoneHref: "tel:+4553358639",

  // Email
  email: "ss@autoxchange.dk",
  emailHref: "mailto:ss@autoxchange.dk",

  // Address
  address: {
    street: "Industrivej 127",
    postalCode: "7080",
    city: "Børkop",
    country: "DK",
    countryName: "Denmark",
    // Approx geo for Industrivej 127, 7080 Børkop. Used by ad-feeds (Meta AIA)
    // and JSON-LD so distance-based targeting works even without a geocoder.
    // Update if the dealership address changes.
    latitude: 55.6347,
    longitude: 9.6175,
  },
  addressLine: "Industrivej 127, 7080 Børkop",
  mapsUrl: "https://maps.google.com/?q=Industrivej+127+7080+Børkop",

  // Web
  websiteUrl: "https://autoxchange.dk",

  // Social profiles — used in footer + sameAs in JSON-LD
  social: {
    facebook: "https://www.facebook.com/autoxchangedk",
    instagram: "https://www.instagram.com/autoxchange",
  },

  // Description used in JSON-LD / footer
  description:
    "Uafhængig bilforhandler i Børkop. Vi håndplukker hver bil og sælger kun det, vi selv ville stå inde for — med fair priser og fuld gennemsigtighed.",

  // Opening hours — used on /kontakt UI + JSON-LD openingHoursSpecification
  openingHours: [
    {
      label: "Mandag – Fredag",
      hours: "09:00 – 16:00",
      // Schema.org openingHoursSpecification (null hours = closed / by appointment)
      days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"] as const,
      opens: "09:00",
      closes: "16:00",
    },
    {
      label: "Lørdag – Søndag",
      hours: "Efter aftale",
      days: ["Saturday", "Sunday"] as const,
      opens: null,
      closes: null,
    },
  ],
  openingHoursNote:
    "Du er altid velkommen til at aftale et tidspunkt uden for normal åbningstid.",
} as const;

export const COPYRIGHT_LINE = (year: number = new Date().getFullYear()) =>
  `© ${year} ${CONTACT.companyName} — CVR ${CONTACT.cvr}`;
